export interface ChapterState {
  index: number;
  localProgress: number;
  transition: number;
}

const clamp = (value: number, min = 0, max = 1) => Math.min(max, Math.max(min, value));

export const chapterState = (progress: number, count: number): ChapterState => {
  if (count <= 0) return { index: 0, localProgress: 0, transition: 0 };

  const safe = clamp(progress);
  if (safe === 1) return { index: count - 1, localProgress: 1, transition: 0 };

  const scaled = safe * count;
  const index = Math.min(count - 1, Math.floor(scaled));
  const localProgress = clamp(scaled - index);
  const transition = index === count - 1 ? 0 : clamp((localProgress - 0.9) / 0.1);

  return { index, localProgress, transition };
};

export const mediaKind = (width: number): "desktop" | "mobile" =>
  width <= 760 ? "mobile" : "desktop";
